import template from './createLaborCategoryModal.html';
import controller from './createLaborCategoryModal.controller';

let CreateLaborCategoryModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreateLaborCategoryModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/createLaborCategoryModal/createLaborCategoryModal.component.js